import { useQuery } from 'react-query';

import { getLogicCheckerSummary as queryFn } from 'api/endPoints/getLogicCheckerSummary';

export const useQueryGetLogicCheckerSummary = (params) => {
    return useQuery<ILogicCheckerSummaryResponse, QueryError>(
        ['getLogicCheckerSummary', params],
        () => queryFn(params),
        {
            enabled: Boolean(params.fileMetaDataId),
        },
    );
};

export interface ILogicCheckerSummaryResponse {
    title: string;
    totalActivities: number;
    totalMilestones: number;
    maxWBSLevel: number;
    overallScore: string;
    overallScoreColor: string;
    notInScoreList: {
        categoryName: string;
        checkName: string;
    }[];
    info: IToolTip;
    inScoreNumber: number;
}
